// Deployment-scoped UI trimming — NOT a security boundary (the underlying
// routes/permissions are unchanged). MTN Moments (moments.ug) doesn't operate
// several modules built for the multi-tenant TKT platform (funding, sales
// channels, merch products, accreditation, subscriptions, most of Platform);
// showing them there is just clutter for every Moments user except the two
// platform engineers who still need to reach everything for support/debugging.
import { BRAND } from './brand';

const FULL_ACCESS_EMAILS = [
  'michaeltendossemwanga@gmail.com',
  'michaeltendossemwanga4543@gmail.com',
  'nicksonmugalula@gmail.com',
  'thimbag@gmail.com',
  'thimba@mookh.africa',
  'leon@mookh.africa',
];

export const isTrimmedForMoments = (email) =>
  BRAND.key === 'moments' && !FULL_ACCESS_EMAILS.includes(String(email || '').trim().toLowerCase());
